import { SimulationFilterWithRouter } from './FiltersReducer.types';
import { Location } from 'history';
import { setTabDataExplorerPathname, setTabLearnPathname, setTabTutorialPathname } from '../../../actions/EditorActions/EditorActions';
import { getDataExplorerPathnameSelector, getLearnPathnameSelector, getTutorialPathnameSelector } from '../../EditorReducer/EditorSelector';
import { SIMULATE_DATA_EXPLORER, SIMULATE_LEARN, SIMULATE_TUTORIAL } from '../../../shared/constants';

export const SIMULATION_FILTERS_WITH_ROUTER: Record<SimulationFilterWithRouter, SimulationFilterWithRouter> = {
  learn: 'learn',
  dataExplorer: 'dataExplorer',
  tutorial: 'tutorial',
};
export const INFO_SIMULATION_FILTERS_MAP = new Map([
  ['learn', 'learn'],
  ['dataExplorer', 'dataExplorer'],
  ['results', 'results'],
  ['tutorial', 'tutorial'],
]);

export const getFullPathname = (location: Location) => `${location.pathname}${location.search}${location.hash}`;
export const getIsDataExplorerPathname = (pathname: string) => {
  return pathname.startsWith(SIMULATE_DATA_EXPLORER);
};
export const getIsLearnPathname = (pathname: string) => {
  return pathname.startsWith(SIMULATE_LEARN);
};

export const getIsTutorialPathname = (pathname: string) => {
  return pathname.startsWith(SIMULATE_TUTORIAL);
};
export const editorRouterFiltersConfig = {
  learn: {
    isPathnameCorrect: getIsLearnPathname,
    setPathnameAction: setTabLearnPathname,
    pathnameSelector: getLearnPathnameSelector,
  },
  dataExplorer: {
    isPathnameCorrect: getIsDataExplorerPathname,
    setPathnameAction: setTabDataExplorerPathname,
    pathnameSelector: getDataExplorerPathnameSelector,
  },
  tutorial: {
    isPathnameCorrect: getIsTutorialPathname,
    setPathnameAction: setTabTutorialPathname,
    pathnameSelector: getTutorialPathnameSelector,
  },
} as const;
